import { ArrowLeftOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import styles from "./Evaluaciones.module.css";

export function EvaluacionesLayout({ titulo, subtitulo, volver, accion, children }) {
  return (
    <main className={styles.page}>
      <div className={styles.topline}>
        <span>CALIDAD / EVALUACIONES</span>
      </div>
      {volver && (
        <Link className={styles.back} to={volver}>
          <ArrowLeftOutlined /> Volver
        </Link>
      )}
      <header className={styles.heading}>
        <div>
          <h1>{titulo}</h1>
          <p>{subtitulo}</p>
        </div>
        {accion}
      </header>
      {children}
    </main>
  );
}
